import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function ConfirmModal({ modal }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(modal.open);
  }, [modal]);

  const handleConfirm = () => {
    modal.confirm(modal.id);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  return (
    <>
      <BootstrapDialog
        fullWidth
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {modal.title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            {modal.description}
          </Typography>
        </DialogContent>
        <DialogActions>
          {!modal.hideCancel && (
          <Button variant="contained" autoFocus onClick={handleClose} color="default">
            Cancelar
          </Button>
          )}
          <Button variant="contained" onClick={handleConfirm} color="primary">
            {modal.confirmText || 'Confirmar'}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}

ConfirmModal.propTypes = {
  modal: PropTypes.object
};
